module.exports = __webpack_public_path__ + "static/media/fj.2739c665.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/fj.svg
// module id = 112
// module chunks = 0